import React from 'react'

import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';

import styles from './styles.module.css'

const NoContent = () => (
    <div className={styles.noContent}>
        <PanoramaFishEyeIcon style={{ fontSize: 20 }}/>
        No content to display
    </div>
)

export default NoContent
